import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Variáveis VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY são obrigatórias.');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export const getSession = async () => {
  const { data, error } = await supabase.auth.getSession();
  if (error) throw error;
  return data.session;
};

export const getCurrentUser = async () => {
  const { data, error } = await supabase.auth.getUser();
  if (error) throw error;
  return data.user;
};

export const USER_TYPES = {
  PSICOLOGO: 'psicologo',
  SUPERVISOR: 'supervisor',
  INSTITUICAO: 'instituicao',
  INTERNACIONAL: 'internacional',
  ADMIN: 'admin',
};

// export default garante compatibilidade com os arquivos que ainda usam
// `import supabase from '@/config/supabaseConfig'` (AuthContext, ResetPasswordPage).
// O named export `export const supabase` (linha 10) cobre `import { supabase } from ...`.
export default supabase;